import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { client } from './client';
import { ContainerContextProvider } from "../store/ContainerContext";
import { AuthStoreProvider } from '@starberry/myaccount-website-utils';
import { hasMyaccount } from "../constant"
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './../react-query/queryClient';

export const wrapRootElement = ({ element }) => (
  <QueryClientProvider client={queryClient}>
    <AuthStoreProvider>
      <div className={hasMyaccount ? 'has-myacc' : 'no-myacc'}>
        <ApolloProvider client={client}>
          <ContainerContextProvider>
            {element}
          </ContainerContextProvider>
        </ApolloProvider>
      </div>
    </AuthStoreProvider>
  </QueryClientProvider>
);
